import React, { useState } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/popup.scss";

const ResetPasswordPopup = ({ isOpen, onClose, userName, onResetPassword }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const validateForm = () => {
    const newErrors = {};

    if (!newPassword) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 6) {
      newErrors.newPassword = "Password must be at least 6 characters";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onResetPassword(newPassword);

    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    onClose();
  };

  const handleClose = () => {
    setNewPassword("");
    setConfirmPassword("");
    setErrors({});
    onClose();
  };

  const handleInputChange = (field, value) => {
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }

    if (field === "newPassword") {
      setNewPassword(value);
    } else if (field === "confirmPassword") {
      setConfirmPassword(value);
    }
  };

  return createPortal(
    <div
      className="common-popup-overlay"
      role="dialog"
      aria-modal="true"
      onClick={handleClose}
    >
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header with-close">
          <h2>Reset Password {userName ? `for ${userName}` : ""}</h2>
          <button className="popup-close-button" onClick={handleClose}>
            ×
          </button>
        </div>
        <div className="popup-content">
          <form onSubmit={handleSubmit}>
            <div className="popup-form-group">
              <label>New Password</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) =>
                  handleInputChange("newPassword", e.target.value)
                }
                className={`popup-input ${errors.newPassword ? "error" : ""}`}
              />
              <p className="popup-help-text" style={{ fontSize: "11px", color: "var(--text-secondary, #6b7280)", marginTop: "4px" }}>
                Must be at least 6 characters.
              </p>
              <div className="popup-error-message">
                {errors.newPassword && <p>{errors.newPassword}</p>}
              </div>
            </div>
            <div className="popup-form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) =>
                  handleInputChange("confirmPassword", e.target.value)
                }
                className={`popup-input ${
                  errors.confirmPassword ? "error" : ""
                }`}
              />
              <div className="popup-error-message">
                {errors.confirmPassword && <p>{errors.confirmPassword}</p>}
              </div>
            </div>

            <div className="popup-actions">
              <button type="submit" className="popup-submit-button">
                Reset Password
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ResetPasswordPopup;
